'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buttonStyles = undefined;

var _theme = require('./theme');

var _spacings = require('./spacings');

var buttonStyles = exports.buttonStyles = {
    fontWeight: _theme.fontWeights.regular,
    colors: {
        buttonAction1: {
            font: _theme.colors.white,
            background: _theme.colors.action1,
            hover: _theme.colors.action1Hover
        },
        buttonAction2: {
            font: _theme.colors.white,
            background: _theme.colors.action2,
            hover: _theme.colors.action2Hover
        },
        buttonBlack: { font: _theme.colors.white, background: _theme.colors.black1 },
        buttonNeutral: { font: _theme.colors.white, background: _theme.colors.saruman },
        buttonSecondaryFull: { font: _theme.colors.white, background: _theme.colors.black2 },
        buttonSecondaryLight: {
            font: _theme.colors.black2,
            background: _theme.colors.white,
            borderColor: _theme.colors.black2
        },
        buttonExpand: {
            font: _theme.colors.white,
            background: _theme.colors.nebula,
            hover: _theme.colors.dawn,
            boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
            hoverBoxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)'
        }
    },
    sizes: {
        buttonSmall: {
            height: '40px',
            borderRadius: '4px',
            fontSize: _theme.fontSizes.h5,
            iconSize: '14px',
            lineHeight: '18px'
        },
        buttonBig: {
            height: '52px',
            borderRadius: '6px',
            fontSize: _theme.fontSizes.h4,
            iconSize: '24px',
            lineHeight: '21px'
        },
        buttonSecondary: {
            height: '32px',
            borderRadius: '16px',
            fontSize: _theme.fontSizes.h5,
            iconSize: '14px',
            lineHeight: '18px'
        },
        buttonExpand: {
            height: '44px',
            borderRadius: '22px',
            fontSize: _theme.fontSizes.h5,
            iconSize: '10px',
            lineHeight: '18px'
        }
    },
    spacings: {
        padding: {
            small: "0 " + _spacings.spacings.small,
            medium: "0 " + _spacings.spacings.medium,
            large: "0 " + _spacings.spacings.large
        },
        width: { fullWidth: '100%', default: 'auto' }
    },
    boxShadows: {
        none: 'none',
        light: '1px 1px 12px rgba(0,0,0,0.08)',
        dark: '0px 5px 15px rgba(0,0,0,0.2)'
    }
};
//# sourceMappingURL=button-styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/design-system/config/data/button-styles.js
// module id = 1909
// module chunks = 0